import { render, staticRenderFns } from "./WebchatProfile.vue?vue&type=template&id=845b03a8&scoped=true&"
import script from "./WebchatProfile.vue?vue&type=script&lang=js&"
export * from "./WebchatProfile.vue?vue&type=script&lang=js&"
import style0 from "./WebchatProfile.vue?vue&type=style&index=0&id=845b03a8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b03a8",
  null
  
)

export default component.exports